// src/components/FancyLoader.jsx
import React from "react";

export default function FancyLoader({ label = "Loading..." }) {
  return (
    <div
      className="fixed inset-0 z-[1000] grid place-items-center bg-white/60 backdrop-blur-[2px]"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-3">
        {/* Rotating ring */}
        <div className="relative h-16 w-16">
          {/* Half dark / half light ring using conic-gradient */}
          <div
            className="
              absolute inset-0 rounded-full
              animate-spin
              shadow-[0_0_20px_rgba(0,0,0,0.06)_inset]
            "
            // Dark half first, then light half
            style={{
              background:
                "conic-gradient(#d97706 0deg 180deg, #fde68a 180deg 360deg)", // amber-600 → amber-200
              animationDuration: "1s",
            }}
          />
          {/* Inner cutout to make it a ring */}
          <div className="absolute inset-[6px] bg-white rounded-full" />
          {/* A small dot riding on the ring head */}
          <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 rounded-full bg-[#b45309]"></span>
        </div>

        {/* Label */}
        <div className="text-sm font-medium text-slate-700 animate-pulse">
          {label}
        </div>
      </div>
    </div>
  );
}
